import reducer from './src/limiter/redux';
import types from './src/limiter/redux/actionTypes';
import * as actions from './src/limiter/redux/actions';
import Captcha from './src/limiter/Captcha';
import CaptchaContainer from './src/limiter/blocks/CaptchaContainer';
import captchaSelector from './src/limiter/redux/selector';

export { default } from './src/superagent';
export * from './src/superagent';

export const limiter = {
  captchaSelector,
  Captcha,
  CaptchaContainer,
  reducer,
  actions,
  types,
};
